import { useSelector } from "react-redux";
import Banner from "../../components/Banner/Banner";
import Contacts from "../../components/Contacts/Contacts";
import Main from "../../components/Main/_index";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Contact = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <>
      <Main
        backimg="img/contactback.jpeg"
        title={translations[selectedLanguages].contactMain.title}
        context={translations[selectedLanguages].contactMain.context}
      />
      <Contacts />
      <Banner />
    </>
  );
};

export default Contact;
